import React, { useEffect, useRef, useState } from "react";

// Inline rename input used by chats and projects in the left rail.
// The parent controls `editing`; this commits on Enter/blur and cancels on Escape.
export function EditableName({ value, onCommit, onCancel, className }) {
  const [text, setText] = useState(value || "");
  const ref = useRef(null);
  useEffect(() => { setText(value || ""); }, [value]);
  useEffect(() => { if (ref.current) { ref.current.focus(); ref.current.select(); } }, []);
  const commit = () => {
    const t = (text || "").trim();
    if (t && t !== value) onCommit(t); else onCancel();
  };
  return (
    <input
      ref={ref}
      value={text}
      data-testid="rail-rename-input"
      onChange={(e) => setText(e.target.value)}
      onClick={(e) => { e.stopPropagation(); }}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === "Enter") { e.preventDefault(); commit(); }
        else if (e.key === "Escape") { e.preventDefault(); onCancel(); }
      }}
      onBlur={commit}
      className={className || "flex-1 min-w-0 bg-[var(--qn-background)] border border-[var(--qn-primary)] rounded px-2 py-1 text-sm outline-none"}
    />
  );
}
